// This should not be used, using the process.env.NODE_ENV direclty will remove the code from production builds
export const IS_DEV: boolean = process.env.NODE_ENV !== 'production';
export const IS_DEV_OR_LOCALHOST: boolean =
    process.env.NODE_ENV === 'development' || window.location.hostname.includes('localhost');
export const CURRENT_HOST: string = window.location.host;
export const LEFT_NAV_FAVORITES = 'ESPLM_LEFT_NAV_FAVORITES';
export const MODULES_TABLE_PREFS_CACHE = 'MODULES_TABLE_PREFS_CACHE_';
// Replace with db port
// export const DB_HOST: string = window.location.host.replace(":3000", "1180");
